var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 122,
    viewBox: "0 0 177 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.56002 101.36L9.02999 82.88H18.45L9.99001 101.46H19.41V82.88H28.16L28.1 119.43H19.41V109.28H7.95998C4.91332 109.28 2.71 108.533 1.35 107.04C0.922546 106.616 0.583208 106.111 0.351524 105.555C0.119841 104.999 0.000407286 104.402 2.28882e-05 103.8C0.0226601 102.958 0.213035 102.128 0.56002 101.36Z",
    fill: "url(#paint0_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.64 107.24V87.14C32.6182 86.5205 32.7312 85.9037 32.9712 85.3322C33.2112 84.7607 33.5724 84.2482 34.03 83.83C35.0418 82.9371 36.3621 82.4742 37.71 82.54C38.2297 82.5433 38.7482 82.5901 39.26 82.68C40.0713 82.7622 40.8367 83.0954 41.4497 83.6331C42.0627 84.1708 42.4928 84.8864 42.68 85.68L46.06 99.76L49.79 85.72C49.9853 84.9375 50.4125 84.2323 51.0157 83.6969C51.6189 83.1615 52.3699 82.821 53.17 82.72C53.6918 82.6288 54.2203 82.5819 54.75 82.58C56.0881 82.519 57.3974 82.9817 58.4 83.87C58.8575 84.2882 59.2188 84.8007 59.4588 85.3722C59.6988 85.9437 59.8118 86.5605 59.79 87.18V107.28H54.26V89.78L50.05 104.46C49.9275 104.984 49.7251 105.487 49.45 105.95C49.1405 106.541 48.6653 107.029 48.0828 107.354C47.5002 107.679 46.8355 107.827 46.17 107.78C44.24 107.78 42.96 106.68 42.34 104.46L38.16 89.78V107.24H32.64Z",
    fill: "url(#paint1_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.37 88.09C63.3732 87.6558 63.4235 87.2233 63.52 86.8C64.14 84.19 66.14 82.88 69.52 82.88H76.4C80.44 82.88 82.46 84.6167 82.46 88.09V101.96C82.46 105.48 80.4267 107.24 76.36 107.24H69.52C68.0815 107.338 66.645 107.022 65.38 106.33C64.3964 105.58 63.7465 104.474 63.57 103.25C63.4762 102.85 63.4259 102.441 63.42 102.03L63.37 88.09ZM69.2 89.78V100.27C69.2 101.4 69.84 101.96 71.12 101.96H74.7C75.97 101.96 76.61 101.46 76.61 100.47V89.78C76.61 88.65 75.97 88.09 74.7 88.09H71.12C69.85 88.09 69.2 88.62 69.2 89.78Z",
    fill: "url(#paint2_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.97 82.88H99.97C102.637 82.88 104.303 83.76 104.97 85.52C105.235 86.4422 105.346 87.4017 105.3 88.36V90.36C105.3 92.71 104.53 94.26 102.97 95.03C104.58 95.66 105.38 97.11 105.38 99.36V101.8C105.38 105.453 103.473 107.28 99.66 107.28H85.93L85.97 82.88ZM91.8 88.09V92.35H98.24C99.14 92.26 99.59 91.83 99.59 91.07V89.44C99.5866 89.2104 99.5264 88.9851 99.4147 88.7845C99.3031 88.5838 99.1434 88.4139 98.95 88.29C98.7302 88.1736 98.4882 88.1055 98.24 88.09H91.8ZM91.8 97.63V101.96H98.2C99.08 101.87 99.51 101.42 99.51 100.61V99.05C99.51 98.24 99.04 97.77 98.08 97.63H91.8Z",
    fill: "url(#paint3_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.96 107.24V82.88H114.79V107.24H108.96Z",
    fill: "url(#paint4_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.32 101.28V82.88H124.15V100.88C124.15 101.6 124.64 101.96 125.62 101.96H135.92V107.24H125.12C124.785 107.245 124.451 107.221 124.12 107.17C122.495 107.202 120.915 106.636 119.68 105.58C118.685 104.378 118.197 102.836 118.32 101.28Z",
    fill: "url(#paint5_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.37 102.16V88.16C138.376 87.7942 138.413 87.4296 138.48 87.07C138.98 84.28 140.83 82.88 144.01 82.88H156.01V88.09H145.51C145.393 88.1493 145.268 88.1931 145.14 88.22C144.834 88.3067 144.568 88.4963 144.385 88.7569C144.203 89.0174 144.116 89.3329 144.14 89.65V92.35H155.99V97.62H144.14V100.33C144.117 100.538 144.139 100.749 144.204 100.948C144.27 101.147 144.378 101.329 144.52 101.483C144.662 101.636 144.836 101.758 145.029 101.838C145.222 101.919 145.431 101.957 145.64 101.95H155.99V107.23H144.78C140.513 107.237 138.377 105.547 138.37 102.16Z",
    fill: "url(#paint6_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.06 87.68C159.06 87.2721 159.111 86.8657 159.21 86.47C159.88 84.07 161.68 82.88 164.59 82.88H176.43V88.09L166.17 88.16C165.31 88.16 164.89 88.59 164.89 89.31V90.93C164.866 91.0421 164.866 91.1579 164.89 91.27C165.01 91.9 165.5 92.27 166.35 92.35H170.94C172.104 92.3294 173.25 92.6342 174.25 93.23C174.943 93.614 175.513 94.1876 175.892 94.8836C176.271 95.5797 176.444 96.3693 176.39 97.16V102.1C176.446 102.944 176.27 103.788 175.88 104.539C175.49 105.29 174.902 105.92 174.18 106.36C173.078 106.973 171.831 107.277 170.57 107.24H159.09V101.96H169.25C170.15 101.69 170.61 101.22 170.61 100.54V98.78C170.61 98.1 170.19 97.72 169.36 97.63H164.51C163.633 97.6712 162.758 97.4956 161.965 97.1189C161.171 96.7422 160.483 96.1759 159.96 95.47C159.381 94.7112 159.065 93.7844 159.06 92.83V87.68Z",
    fill: "url(#paint7_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.91 119.07H35.91L35.82 118.75C35.3885 119.02 34.8891 119.162 34.38 119.16C33.5 119.16 33.12 118.58 33.12 117.77C33.12 116.77 33.55 116.45 34.53 116.45H35.69V115.96C35.69 115.44 35.54 115.25 34.77 115.25C34.3194 115.255 33.8705 115.305 33.43 115.4L33.28 114.5C33.822 114.358 34.3797 114.284 34.94 114.28C36.46 114.28 36.94 114.8 36.94 115.98L36.91 119.07ZM35.7 117.29H34.79C34.39 117.29 34.28 117.4 34.28 117.76C34.28 118.12 34.39 118.23 34.77 118.23C35.0881 118.224 35.4001 118.141 35.68 117.99L35.7 117.29Z",
    fill: "url(#paint8_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.58 119.07V112.46L41.79 112.29V119.07H40.58Z",
    fill: "url(#paint9_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.56 119.07V112.46L46.77 112.29V119.07H45.56Z",
    fill: "url(#paint10_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.48 118.2C52.9811 118.195 53.4792 118.121 53.96 117.98L54.15 118.87C53.5769 119.065 52.9753 119.163 52.37 119.16C50.85 119.16 50.37 118.48 50.37 117.35V116.11C50.37 115.11 50.82 114.28 52.37 114.28C53.92 114.28 54.26 115.16 54.26 116.17V117.17H51.58V117.41C51.54 117.98 51.79 118.2 52.48 118.2ZM51.54 116.2H53.07V115.96C53.07 115.52 52.94 115.21 52.34 115.21C51.74 115.21 51.54 115.52 51.54 115.96V116.2Z",
    fill: "url(#paint11_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.19 119.16C58.6262 119.154 58.0666 119.063 57.53 118.89L57.7 118C58.1696 118.127 58.6535 118.195 59.14 118.2C59.67 118.2 59.75 118.09 59.75 117.73C59.75 117.37 59.69 117.29 58.91 117.11C57.73 116.83 57.59 116.54 57.59 115.64C57.59 114.74 58.01 114.28 59.39 114.28C59.8777 114.282 60.3637 114.335 60.84 114.44L60.72 115.38C60.2811 115.298 59.8364 115.251 59.39 115.24C58.87 115.24 58.78 115.36 58.78 115.65C58.78 115.94 58.78 116.05 59.46 116.22C60.81 116.56 60.94 116.74 60.94 117.7C60.94 118.66 60.65 119.16 59.19 119.16Z",
    fill: "url(#paint12_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.48 119.07H69.88L68.33 114.38H69.57L70.67 117.94L71.79 114.38H73.03L71.48 119.07Z",
    fill: "url(#paint13_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.03 119.16C76.38 119.16 75.93 118.28 75.93 117.31V116.13C75.93 115.13 76.38 114.28 78.03 114.28C79.68 114.28 80.14 115.17 80.14 116.13V117.31C80.14 118.28 79.69 119.16 78.03 119.16ZM78.03 115.28C77.39 115.28 77.14 115.56 77.14 116.09V117.35C77.14 117.88 77.39 118.16 78.03 118.16C78.67 118.16 78.93 117.88 78.93 117.35V116.09C78.93 115.56 78.68 115.28 78.03 115.28Z",
    fill: "url(#paint14_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.57 119.16C83.92 119.16 83.47 118.28 83.47 117.31V116.13C83.47 115.13 83.92 114.28 85.57 114.28C87.22 114.28 87.68 115.17 87.68 116.13V117.31C87.68 118.28 87.23 119.16 85.57 119.16ZM85.57 115.28C84.93 115.28 84.68 115.56 84.68 116.09V117.35C84.68 117.88 84.93 118.16 85.57 118.16C86.21 118.16 86.47 117.88 86.47 117.35V116.09C86.47 115.56 86.22 115.28 85.57 115.28Z",
    fill: "url(#paint15_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.72 115.36C93.2762 115.553 92.8482 115.78 92.44 116.04V119.04H91.23V114.35H92.23L92.31 114.87C92.7018 114.604 93.1295 114.396 93.58 114.25L93.72 115.36Z",
    fill: "url(#paint16_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.57 114.38V119.32C102.57 119.92 102.35 120.2 101.31 121.06L100.61 120.31C101.3 119.68 101.36 119.65 101.36 119.16V114.38H102.57ZM101.36 113.71V112.35H102.57V113.71H101.36Z",
    fill: "url(#paint17_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.23 118.2C108.728 118.196 109.223 118.122 109.7 117.98L109.89 118.87C109.317 119.067 108.715 119.165 108.11 119.16C106.6 119.16 106.11 118.48 106.11 117.35V116.11C106.11 115.11 106.57 114.28 108.11 114.28C109.65 114.28 110.01 115.16 110.01 116.17V117.17H107.32V117.41C107.28 117.98 107.49 118.2 108.23 118.2ZM107.28 116.2H108.79V115.96C108.79 115.52 108.65 115.21 108.06 115.21C107.47 115.21 107.25 115.52 107.25 115.96L107.28 116.2Z",
    fill: "url(#paint18_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.79 119.07V115.79C120.79 115.54 120.68 115.42 120.4 115.42C119.959 115.467 119.531 115.599 119.14 115.81V119.07H117.93V114.38H118.85L118.97 114.77C119.574 114.479 120.23 114.312 120.9 114.28C121.086 114.261 121.273 114.299 121.437 114.388C121.601 114.477 121.735 114.614 121.82 114.78C122.424 114.479 123.085 114.309 123.76 114.28C124.57 114.28 124.85 114.83 124.85 115.67V119.07H123.64V115.79C123.64 115.54 123.53 115.42 123.26 115.42C122.818 115.462 122.389 115.595 122 115.81V119.07H120.79Z",
    fill: "url(#paint19_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.44 119.16C128.78 119.16 128.33 118.28 128.33 117.31V116.13C128.33 115.13 128.78 114.28 130.44 114.28C132.1 114.28 132.54 115.17 132.54 116.13V117.31C132.54 118.28 132.09 119.16 130.44 119.16ZM130.44 115.28C129.79 115.28 129.54 115.56 129.54 116.09V117.35C129.54 117.88 129.79 118.16 130.44 118.16C131.09 118.16 131.33 117.88 131.33 117.35V116.09C131.33 115.56 131.08 115.28 130.44 115.28Z",
    fill: "url(#paint20_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.19 117.27C140.19 118.4 139.83 119.16 137.97 119.16C137.34 119.161 136.711 119.108 136.09 119V112.46L137.3 112.29V114.56C137.756 114.38 138.24 114.285 138.73 114.28C139.73 114.28 140.19 114.9 140.19 115.89V117.27ZM137.3 118.12C137.543 118.136 137.787 118.136 138.03 118.12C138.82 118.12 138.98 117.81 138.98 117.27V115.82C138.98 115.44 138.81 115.24 138.36 115.24C137.993 115.264 137.634 115.356 137.3 115.51V118.12Z",
    fill: "url(#paint21_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.71 113.71V112.35H144.92V113.71H143.71ZM143.71 119.07V114.38H144.92V119.07H143.71Z",
    fill: "url(#paint22_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.63 118.2C151.131 118.195 151.629 118.121 152.11 117.98L152.29 118.87C151.721 119.066 151.122 119.164 150.52 119.16C149 119.16 148.47 118.48 148.47 117.35V116.11C148.47 115.11 148.93 114.28 150.47 114.28C152.01 114.28 152.36 115.16 152.36 116.17V117.17H149.67V117.41C149.68 117.98 149.89 118.2 150.63 118.2ZM149.68 116.2H151.22V115.96C151.22 115.52 151.08 115.21 150.49 115.21C149.9 115.21 149.68 115.52 149.68 115.96V116.2Z",
    fill: "url(#paint23_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.84 119.07V112.46L157.06 112.29V119.07H155.84Z",
    fill: "url(#paint24_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.4 118.98C163.055 119.097 162.694 119.158 162.33 119.16C161.45 119.16 161 118.76 161 117.92V115.31H160.28V114.38H161V113.21L162.21 113.05V114.38H163.46L163.38 115.31H162.21V117.77C162.21 118.02 162.33 118.18 162.65 118.18C162.856 118.172 163.061 118.142 163.26 118.09L163.4 118.98Z",
    fill: "url(#paint25_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.92 114.38V119.32C167.92 119.92 167.7 120.2 166.66 121.06L165.95 120.31C166.65 119.68 166.71 119.65 166.71 119.16V114.38H167.92ZM166.71 113.71V112.35H167.92V113.71H166.71Z",
    fill: "url(#paint26_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.57 118.2C174.071 118.197 174.57 118.123 175.05 117.98L175.24 118.87C174.667 119.066 174.065 119.164 173.46 119.16C171.95 119.16 171.46 118.48 171.46 117.35V116.11C171.46 115.11 171.92 114.28 173.46 114.28C173.718 114.239 173.981 114.259 174.229 114.34C174.477 114.42 174.703 114.558 174.887 114.743C175.072 114.927 175.21 115.153 175.29 115.401C175.371 115.649 175.391 115.912 175.35 116.17V117.17H172.66V117.41C172.63 117.98 172.84 118.2 173.57 118.2ZM172.63 116.2H174.17V115.96C174.17 115.52 174.03 115.21 173.44 115.21C172.85 115.21 172.63 115.52 172.63 115.96V116.2Z",
    fill: "url(#paint27_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M128.55 70.3C128.55 73.18 112.28 75.51 92.21 75.51C72.14 75.51 55.87 73.18 55.87 70.3C55.87 67.42 72.14 65.1 92.21 65.1C112.28 65.1 128.55 67.43 128.55 70.3Z",
    fill: "url(#paint28_radial_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.17 44.21C63.1794 43.5225 63.3221 42.8433 63.59 42.21L67.39 33.14L64.8 35.65C63.5867 36.8168 62.7794 38.342 62.4968 40.0015C62.2142 41.661 62.4712 43.3673 63.23 44.87C63.1921 44.652 63.1721 44.4313 63.17 44.21Z",
    fill: "url(#paint29_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.47 35.7L114.61 32.93V49.83L117.47 47.06C118.233 46.324 118.841 45.4417 119.255 44.4658C119.67 43.4899 119.884 42.4404 119.884 41.38C119.884 40.3196 119.67 39.2701 119.255 38.2942C118.841 37.3183 118.233 36.436 117.47 35.7Z",
    fill: "url(#paint30_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.53 35.62L103.9 53.27C103.77 53.893 103.548 54.493 103.24 55.05C102.936 55.7398 102.428 56.3202 101.784 56.7134C101.141 57.1066 100.393 57.2938 99.64 57.25C97.52 57.25 96.1167 55.9167 95.43 53.25L90.84 35.62V56.62H84.72V32.46C84.69 31.7243 84.8101 30.9902 85.0732 30.3025C85.3362 29.6148 85.7366 28.9878 86.25 28.46C86.7836 27.9395 87.4184 27.5343 88.1151 27.2694C88.8118 27.0045 89.5555 26.8856 90.3 26.92C90.8704 26.9201 91.4396 26.9737 92 27.08C92.9319 27.2173 93.7969 27.6449 94.4719 28.3019C95.1469 28.959 95.5976 29.8121 95.76 30.74L99.48 47.65L103.61 30.74C103.786 29.8249 104.236 28.985 104.901 28.3314C105.565 27.6778 106.412 27.2414 107.33 27.08C107.707 27.012 108.088 26.9686 108.47 26.95L96.98 15.79C95.4094 14.2788 93.3146 13.4346 91.135 13.4346C88.9554 13.4346 86.8606 14.2788 85.29 15.79L73.29 27.45H76.7L70.5 42.32H77.4V27.47H83.79V56.73H77.42V48.62H69.03C67.9271 48.6518 66.8299 48.4508 65.81 48.03L85.32 66.97C86.8906 68.4812 88.9854 69.3254 91.165 69.3254C93.3446 69.3254 95.4394 68.4812 97.01 66.97L108.56 55.75L108.53 35.62Z",
    fill: "url(#paint31_linear_1_1378)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.73 26.77L97.73 18.01C93.27 13.67 89.54 13.51 84.9 18.01L75.75 26.9C86.06 26.62 96.39 26.75 106.73 26.77Z",
    fill: "url(#paint32_linear_1_1378)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1378",
    x1: 14.08,
    y1: 82.88,
    x2: 14.08,
    y2: 119.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAE097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#649E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ADCF41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#9CC837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#81BC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2CF7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1378",
    x1: 46.23,
    y1: 82.54,
    x2: 46.23,
    y2: 107.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_1378",
    x1: 72.9,
    y1: 82.88,
    x2: 72.9,
    y2: 107.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_1378",
    x1: 95.7,
    y1: 82.88,
    x2: 95.7,
    y2: 107.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_1378",
    x1: 111.87,
    y1: 82.88,
    x2: 111.87,
    y2: 107.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_1378",
    x1: 127.12,
    y1: 82.88,
    x2: 127.12,
    y2: 107.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_1378",
    x1: 147.21,
    y1: 82.88,
    x2: 147.21,
    y2: 107.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_1378",
    x1: 167.75,
    y1: 82.88,
    x2: 167.75,
    y2: 107.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_1378",
    x1: 35.02,
    y1: 114.28,
    x2: 35.02,
    y2: 119.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_1378",
    x1: 41.19,
    y1: 112.29,
    x2: 41.19,
    y2: 119.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_1378",
    x1: 46.17,
    y1: 112.29,
    x2: 46.17,
    y2: 119.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_1378",
    x1: 52.28,
    y1: 114.28,
    x2: 52.28,
    y2: 119.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_1378",
    x1: 59.23,
    y1: 114.28,
    x2: 59.23,
    y2: 119.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_1378",
    x1: 70.68,
    y1: 114.38,
    x2: 70.68,
    y2: 119.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_1378",
    x1: 78.03,
    y1: 114.28,
    x2: 78.03,
    y2: 119.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_1378",
    x1: 85.58,
    y1: 114.28,
    x2: 85.58,
    y2: 119.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_1378",
    x1: 92.47,
    y1: 114.28,
    x2: 92.47,
    y2: 119.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_1378",
    x1: 101.59,
    y1: 112.35,
    x2: 101.59,
    y2: 121.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_1378",
    x1: 108.02,
    y1: 114.28,
    x2: 108.02,
    y2: 119.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_1378",
    x1: 121.37,
    y1: 114.28,
    x2: 121.37,
    y2: 119.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_1378",
    x1: 130.44,
    y1: 114.28,
    x2: 130.44,
    y2: 119.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_1378",
    x1: 138.14,
    y1: 112.29,
    x2: 138.14,
    y2: 119.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_1378",
    x1: 144.32,
    y1: 112.35,
    x2: 144.32,
    y2: 119.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1_1378",
    x1: 150.42,
    y1: 114.28,
    x2: 150.42,
    y2: 119.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1_1378",
    x1: 156.45,
    y1: 112.29,
    x2: 156.45,
    y2: 119.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1_1378",
    x1: 161.87,
    y1: 113.05,
    x2: 161.87,
    y2: 119.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1_1378",
    x1: 166.94,
    y1: 112.35,
    x2: 166.94,
    y2: 121.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1_1378",
    x1: 173.37,
    y1: 114.28,
    x2: 173.37,
    y2: 119.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2C2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_1_1378",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.298 70.617) scale(32.0437 3.6738)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1_1378",
    x1: 64.89,
    y1: 33.19,
    x2: 64.89,
    y2: 44.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAE097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#649E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ADCF41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#9CC837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#81BC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2CF7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1_1378",
    x1: 117.25,
    y1: 32.93,
    x2: 117.25,
    y2: 49.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAE097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#649E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ADCF41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#9CC837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#81BC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2CF7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1_1378",
    x1: 87.16,
    y1: 13.46,
    x2: 87.16,
    y2: 69.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAE097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#649E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ADCF41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#9CC837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#81BC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2CF7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1_1378",
    x1: 91.23,
    y1: 14.69,
    x2: 91.23,
    y2: 27.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "white",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "white",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176.44,
    height: 121.06,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.216af6954569ddb9ae31d4965a8ad038.svg";
export { ForwardRef as ReactComponent };